// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/notify/v1/notify.proto" (package "c1.api.notify.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Notify } from "./notify";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { NotifyResponse } from "./notify";
import type { NotifyRequest } from "./notify";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.notify.v1.Notify
 */
export interface INotifyClient {
    /**
     * @generated from protobuf rpc: Notify
     */
    notify(input: NotifyRequest, options?: RpcOptions): ServerStreamingCall<NotifyRequest, NotifyResponse>;
}
/**
 * @generated from protobuf service c1.api.notify.v1.Notify
 */
export class NotifyClient implements INotifyClient, ServiceInfo {
    typeName = Notify.typeName;
    methods = Notify.methods;
    options = Notify.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Notify
     */
    notify(input: NotifyRequest, options?: RpcOptions): ServerStreamingCall<NotifyRequest, NotifyResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotifyRequest, NotifyResponse>("serverStreaming", this._transport, method, opt, input);
    }
}
